<template>
  <div class="content-config">
    <div class="search-line">
      <a-form-model
        ref="searchForm"
        :model="searchForm"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16}"
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="所属系统" class="form-item">
              <a-select
                v-model="searchForm.plateformId"
                placeholder="请选择所属系统"
                style="width: 100%"
                allow-clear
                @change="selectSystem"
              >
                <a-select-option v-for="item in systemOptions" :key="item.plateformId" :value="item.plateformId">
                  {{ item.plateformName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item label="所属模块" class="form-item">
              <a-select
                v-model="searchForm.moduleId"
                placeholder="请选择所属模块"
                style="width: 100%"
                :disabled="!searchForm.plateformId"
                allow-clear
                @change="selectModule"
              >
                <a-select-option v-for="item in moduleOptions" :key="item.id" :value="item.id">
                  {{ item.moduleName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item label="标签路径" class="form-item">
              <a-cascader
                v-model="searchForm.categoryPathList"
                :options="tagOptions"
                :field-names="{
                  label: 'name',
                  value: 'path',
                  children: 'children'
                }"
                :change-on-select="true"
                placeholder="请选择标签路径"
                style="width: 100%"
                :disabled="!searchForm.plateformId||!searchForm.moduleId"
                allow-clear
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item label="状态" class="form-item">
              <a-select
                v-model="searchForm.state"
                placeholder="请选择状态"
                style="width: 100%"
                allow-clear
              >
                <a-select-option :value="0">禁用</a-select-option>
                <a-select-option :value="1">启用</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item label="模块创建人" class="form-item">
              <a-input
                v-model="searchForm.createBy"
                placeholder="请输入模块创建人"
                style="width: 100%"
                allow-clear
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="模块创建时间" class="form-item">
              <a-range-picker
                v-model="searchForm.createTime"
                style="width: 100%"
                :show-time="{ format: 'HH:mm:ss' }"
                format="YYYY-MM-DD HH:mm:ss"
                valueFormat="YYYY-MM-DD HH:mm:ss"
                allow-clear
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item class="form-item operation-item" :wrapper-col="{ span: 24 }">
              <a-button @click="handleReset">重置</a-button>
              <a-button style="margin-left: 8px" type="primary" @click="handleSearch">查询</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <div class="operation-bar">
      <a-space>
        <a-button @click="$refs.xGrid.setAllTreeExpand(true)">展开所有</a-button>
      </a-space>
      <a-button 
        type="primary" 
        @click="handleAdd"
        v-if="btnParamNumbersInfo.some(btn=>btn.btnName=='新增模块')"
        >新增模块</a-button>
    </div>
    <div class="table-container">
      <vxe-grid
        ref="xGrid"
        v-bind="gridOptions"
        :data="tableData"
        @page-change="onPageChange"
      >
        <template #operate="{ row ,data}">
          <a-space>
            <template v-if="btnParamNumbersInfo.some(btn=>btn.btnName=='添加标签')">
              <a-button
                v-if="hasEditStatus(row)"
                size="small"
                type="link"
                @click="saveRowEvent(row,data)"
              >保存
              </a-button>
              <a-button
                v-else
                size="small"
                type="link"
                @click="handleEdit(row)"
              >
                编辑
              </a-button>
            </template>
            <a-button
              v-if="row.leve == 0 && row.moduleId || row.leve > 0 && row.id&&btnParamNumbersInfo.some(btn=>btn.btnName=='启用')"
              size="small"
              type="link"
              @click="handleToggleState(row)"
            >
              {{ row.state === 1 ? '禁用' : '启用' }}
            </a-button>
            <a-button
              v-if="canAddChild(row)&&btnParamNumbersInfo.some(btn=>btn.btnName=='添加标签')"
              size="small"
              type="link"
              @click="handleAddChild(row)"
            >
              添加{{ getAddButtonText(row) }}
            </a-button>
          </a-space>
        </template>
      </vxe-grid>

      <module-form
        v-model="moduleFormVisible"
        :type="moduleFormType"
        :edit-data="moduleFormData"
        @submit="handleModuleSubmit"
      />
    </div>
  </div></template>

<script>
import {
  deleteContentConfig,
  queryStudyModulePage,
  createStudyModule,
  updateStudyModule,
  setDisableModule,
  updateDeveloperCategoryState,
  createDeveloperCategory,
  updateDeveloperCategory,
  listCategoryInfo,
  listPlateformInfo
} from '@/api/news'
import TableMixin from '@/common/advancedTable'
import ModuleForm from './ModuleForm.vue'

import commonMethods from '@/common/commonMethods'
import { removeEmptyChildren,getPageBtnsFn } from '@/common/common.js'
import {mapState} from 'vuex'
export default {
  name: 'ContentConfig',
  components: {
    ModuleForm
  },
  mixins: [TableMixin, commonMethods],
  data() {
    return {
      moduleFormVisible: false,
      moduleFormType: 'add',
      moduleFormData: {},
      editModalVisible: false,
      editModalTitle: '',
      tableColumns: [
        { field: 'plateformName', title: '所属系统', width: 150 },
        // { field: 'plateformId', title: '系统ID', width: 100 },

        { field: 'moduleName', title: '模块名称', width: 150 },
        { field: 'moduleId', title: '模块ID', width: 80 },
        {
          field: 'firstTag',
          title: '一级标签',
          width: 100,
          editRender: {
            name: 'input',
            attrs: {
              placeholder: '请输入一级标签'
            },
            immediate:true
          }
        },
        {
          field: 'secondTag',
          title: '二级标签',
          width: 100,
          editRender: {
            name: 'input',
            attrs: {
              placeholder: '请输入二级标签'
            },
            immediate:true
          }
        },
        {
          field: 'thirdTag',
          title: '三级标签',
          width: 100,
          editRender: {
            name: 'input',
            attrs: {
              placeholder: '请输入三级标签'
            },
            immediate:true
          }
        },
        { field: 'state', title: '状态', width: 60,
          formatter: ({ cellValue }) => cellValue === 1 ? '启用' : '禁用'
        },
        // { field: 'children', title: '下级标签列表', width: 120 },
        // { field: 'hasChildren', title: '是否存在下级标签', width: 120 },
        { field: 'createDate', title: '创建时间', width: 140 },
        { field: 'createBy', title: '创建人', width: 90 },
        { field: 'lastUpdateDate', title: '更新时间', width: 140 },
        { field: 'lastUpdateBy', title: '更新人', width: 90 }
      ],
      tableData: [],
      gridOptions: {
        loading: false,
        minHeight: 440,
        height: '100%',
        maxHeight: '100%',
        size: 'mini',
        data: [], // 移除模拟数据
        columns: [],
        scrollX: {
          enabled: true
        },
        scrollY: {
          enabled: true, gt: 10
        },
        treeConfig: {
          indent: 20,
          expandAll: false,
          transform: true,
          parentField: 'parentId',
          rowField: 'selfId',
          iconOpen: 'vxe-icon-square-minus',
          iconClose: 'vxe-icon-square-plus'
        },
        editConfig: {
          trigger: 'manual',
          mode: 'cell',
          showStatus: true,
          autoClear: false,
          beforeEditMethod: ({ row, column }) => {
            // 只有启用状态的行才能编辑
            if (row.state !== 1) {
              return false
            }
            // 根据行的层级控制可编辑的字段
            switch (row.leve) {
              case 1:
                return column.field === 'firstTag'
              case 2:
                return column.field === 'secondTag'
              case 3:
                return column.field === 'thirdTag'
              default:
                return false
            }
          }
        },
        editRules: {
          firstTag: [
            { required: true, message: '请输入一级标签' },
            { min: 2, max: 20, message: '标签长度在2-20个字符之间' }
          ],
          secondTag: [
            { required: true, message: '请输入二级标签' },
            { min: 2, max: 20, message: '标签长度在2-20个字符之间' }
          ],
          thirdTag: [
            { required: true, message: '请输入三级标签' },
            { min: 2, max: 20, message: '标签长度在2-20个字符之间' }
          ]
        },
        pagerConfig: {
          pageSize: 20,
          pageSizes: [10, 20, 50, 100],
          layouts: ['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total'],
          total: 0,
          currentPage: 1,
        }
      },
      editForm: {
        id: null,
        name: '',
        parentId: null,
        level: 0
      },
      currentOperation: '', // 'edit' or 'add'
      searchForm: {
        plateformId: undefined,
        moduleId: undefined,
        state: undefined,
        categoryPathList: [],
        operator: '',
        operatorId: '',
        operatorName: ''
      },
      systemOptions: [],
      moduleOptions: [],
      tagOptions: [],
      btnParamNumbersInfo:[]
    }
  },
  computed:{
    ...mapState('setting', ['isImplant']),
  },
  mounted() {
    this.init()
    this.loadData()
    this.loadSystemOptions()
  },
  methods: {
    init() {
      this.gridOptions = Object.assign({}, this.defaultGridOptions, this.gridOptions, {
        columns: this.preprocessColumns(
          this.tableColumns,
          { sequence: { show: true, fixed: 'left', width: 150, treeNode: true },
            operation: { width: 215 }
          }),
      })
      this.setActionBtnsFn()
    },
     /*设置按钮权限*/
     async setActionBtnsFn() {
   
      let metaObj = this.$route.meta
      if(this.isImplant&&sessionStorage.getItem('routerMate')){
        metaObj = JSON.parse(sessionStorage.getItem('routerMate'))
      }
      const res = await getPageBtnsFn({}, metaObj)
      this.btnParamNumbersInfo = res.btnParamNumbersInfo
    },

    // 加载数据
    async loadData(row = null) {
      this.gridOptions.loading = true
      try {
        const params = {
          ...this.searchForm,
          categoryPath: this.searchForm.categoryPathList.length > 0 ? this.searchForm.categoryPathList[this.searchForm.categoryPathList.length - 1] : '',
          pageNo: this.gridOptions.pagerConfig.currentPage,
          pageSize: this.gridOptions.pagerConfig.pageSize,
        }
        const res = await queryStudyModulePage(params)
        if (res.head.cost === 0) {
          this.tableData = this.convertToFlatArray(res.body.data)
          this.gridOptions.pagerConfig.total = res.body.totalRow || 0

          if (row) {
            this.$nextTick(() => {
              // 缺少row.id!!展开不生效
              this.$refs.xGrid.setTreeExpand(row, true) // 将父节点展开
            })
          }
        } else {
          this.$message.error(res.head.message || '查询失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('加载数据失败')
      } finally {
        this.gridOptions.loading = false
      }
    },
    // 将树形数据转换为一维数组
    convertToFlatArray(treeData) {
      const result = []
      const flatten = (items, parent = {}, parentId = null, leve = 0) => {
        items.forEach(item => {
          const { children, ...rest } = item
          // 构建基础数据
          const flatItem = {
            ...rest,
            leve,
            parentId: parentId || rest.parentId || null,
            plateformName: rest.plateformName || parent.plateformName || '',
            moduleName: rest.moduleName || parent.moduleName || '',
            moduleId: rest.moduleId || parent.moduleId || 0,
            plateformId: rest.plateformId || parent.plateformId || 0,
            state: rest.state || 0,
            id: rest.id || null,
            selfId: leve == 0 ? (leve + '_' + rest.moduleId) : (leve + '_' + rest.id)
          }

          // 根据层级设置标签
          if (leve === 1) {
            flatItem.firstTag = rest.name || parent.firstTag || ''
          } else if (leve === 2) {
            flatItem.firstTag = parent.firstTag || ''
            flatItem.secondTag = rest.name || parent.secondTag || ''
          } else if (leve === 3) {
            // const parentNode = this.findParentNode(rest.parentId, treeData)
            // const grandParentNode = parentNode ? this.findParentNode(parentNode.parentId, treeData) : null
            flatItem.firstTag = parent.firstTag || ''
            flatItem.secondTag = parent.secondTag || ''
            flatItem.thirdTag = rest.name || parent.thirdTag || ''
          }

          result.push(flatItem)

          if (children && children.length > 0) {
            flatten(children, flatItem, flatItem.selfId, leve + 1)
          }
        })
      }

      flatten(treeData)
      return result
    },

    // 查找父级标签名称
    findParentTag(items, parentId, field) {
      for (const item of items) {
        if (item.selfId === parentId) {
          return item[field]
        }
        if (item.children) {
          const found = this.findParentTag(item.children, parentId, field)
          if (found) return found
        }
      }
      return ''
    },

    // 分页改变
    onPageChange({ currentPage, pageSize }) {
      // 这里可以处理分页逻辑
      console.log('当前页：', currentPage, '每页条数：', pageSize)
      this.gridOptions.pagerConfig.currentPage = currentPage
      this.gridOptions.pagerConfig.pageSize = pageSize
      this.loadData()
    },

    // 查找父节点
    findParentNode(id, data = this.tableData) {
      for (const item of data) {
        if (item.children) {
          if (item.children.some(child => child.selfId === id)) {
            return item
          }
          const found = this.findParentNode(id, item.children)
          if (found) return found
        }
      }
      return null
    },
    // 判断是否可以添加子节点
    canAddChild(row) {
      // 如果已经有三级标签，则不能再添加
      return row.leve <= 2 && (row.leve == 0 && row.moduleId || row.leve > 0 && row.id)
    },
    // 获取添加按钮文本
    getAddButtonText(row) {
      // 根据当前节点的 leve 判断下一级标签类型
      switch (row.leve) {
        case 0:
          return '一级标签'
        case 1:
          return '二级标签'
        case 2:
          return '三级标签'
        default:
          return null
      }
    },

    // 新增处理
    handleAdd() {
      this.moduleFormType = 'add'
      this.moduleFormData = {}
      this.moduleFormVisible = true
    },
    async saveRowEvent(row,data) {
      // 校验
      const isPass = await this.handleEditClosed({ row })
      if (!isPass) return
      const params = {
        moduleId: row.moduleId,
        name: row.leve === 1 ? row.firstTag : row.leve === 2 ? row.secondTag : row.thirdTag,
        parentId: row.leve === 1 ? 0 : this.findParentNode(row.selfId).id,
        plateformId: row.plateformId
      }
      if (!row.id) {
        const res = await createDeveloperCategory(params)
        if (res.head.cost === 0) {
          this.$message.success('保存成功')
          this.loadData(row) // 重新加载数据
          this.loadSystemOptions()
        } else {
          this.$message.error(res.head.message || '保存失败')
        }
      } else {
        params.id = row.id
        const res = await updateDeveloperCategory(params)
        this.loadSystemOptions()
        if (res.head.cost === 0) {
          this.$refs.xGrid.clearEdit()
        } else {
          this.$message.error(res.head.message || '保存失败')
        }
      }
    },
    hasEditStatus(row) {
      const $grid = this.$refs.xGrid
      if ($grid) {
        return $grid.isEditByRow(row)
      }
    },

    // 编辑处理
    handleEdit(row) {
      if (row.leve === 0) {
        this.moduleFormType = 'edit'
        this.moduleFormData = row
        this.moduleFormVisible = true
      } else if (row.leve === 1) {
        this.$refs.xGrid.setEditCell(row, 'firstTag')
      } else if (row.leve === 2) {
        this.$refs.xGrid.setEditCell(row, 'secondTag')
      } else if (row.leve === 3) {
        this.$refs.xGrid.setEditCell(row, 'thirdTag')
      }
    },

    // 切换状态处理
    handleToggleState(row) {
      const newState = row.state === 1 ? 0 : 1
      const actionText = newState === 1 ? '启用' : '禁用'

      this.$confirm({
        title: `确认${actionText}`,
        content: `确定要${actionText}该项吗？`,
        onOk: () => {
          return new Promise(
            async(resolve, reject) => {
              const params = {
                id: row.id,
                state: newState
              }
              if (row.leve === 0) {
                params.moduleId = row.moduleId
              }
              const updataApi = row.leve === 0 ? setDisableModule : updateDeveloperCategoryState
              const res = await updataApi(params)

              if (res.head.cost === 0) {
                this.$message.success(`${actionText}成功`)
                this.loadData()
                resolve()
              } else {
                this.$message.error(res.head.message || `${actionText}失败`)
                reject(new Error(res.head.message))
              }
            })
        }
      })
    },

    // 删除处理
    handleDelete(row) {
      if (row.children && row.children.length > 0) {
        this.$message.error('该节点下存在子节点，无法删除')
        return
      }

      this.$confirm({
        title: '确认删除',
        content: '确定要删除该项吗？',
        onOk: () => {
          return new Promise((resolve, reject) => {
            deleteContentConfig({ id: row.id })
              .then(() => {
                this.deleteNode(row.id);
                this.$message.success('删除成功');
                resolve();
              })
              .catch(err => {
                this.$message.error('删除失败');
                reject(err);
              });
          });
        }
      });
    },

    // 删除节点
    deleteNode(id, data = this.tableData) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === id) {
          data.splice(i, 1)
          return true
        }
        if (data[i].children) {
          if (this.deleteNode(id, data[i].children)) {
            return true
          }
        }
      }
      return false
    },

    // 添加子节点处理
    async handleAddChild(row) {
      const $table = this.$refs.xGrid
      const record = {
        plateformName: row.plateformName,
        moduleName: row.moduleName,
        plateformId: row.plateformId,
        moduleId: row.moduleId,
        firstTag: row.firstTag || '',
        secondTag: row.secondTag || '',
        thirdTag: row.thirdTag || '',
        parentId: row.selfId, // 需要指定父节点，自动插入该节点中
        state: 1,
        children: [],
        leve: row.leve + 1,
      }
      const { row: newRow } = await $table.insertAt(record, -1)

      await $table.setTreeExpand(row, true) // 将父节点展开
      if (row.leve === 0) {
        await $table.setEditCell(newRow, 'firstTag')
      } else if (row.leve === 1) {
        await $table.setEditCell(newRow, 'secondTag')
      } else if (row.leve === 2) {
        await $table.setEditCell(newRow, 'thirdTag')
      }
    },

    // 处理表单提交
    async handleModuleSubmit(formData) {
      try {
        if (this.moduleFormType === 'edit') {
          await updateStudyModule({ ...formData, moduleId: this.moduleFormData.moduleId })
          this.loadData() // 重新加载数据
        } else {
          const res = await createStudyModule(formData)
          if (res.head.retCode === '0000') {
            this.$message.success('添加成功')
           
            this.loadData() // 重新加载数据
          } else {
            
            this.$message.error(res.head.retDesc || '添加失败')
            return
          }
        }
        this.moduleFormVisible = false
        this.loadSystemOptions()
      } catch (err) {
        console.error('操作失败:', err)
        this.$message.error(err.message || '操作失败')
      }
    },

    // 更新节点
    updateNode(id, newData, data = this.tableData) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id === id) {
          this.$set(data, i, { ...data[i], ...newData })
          return true
        }
      }
      return false
    },

    // 加载系统选项
    async loadSystemOptions() {
      try {
        // 这里需要替换为实际的API调用
        const res = await listPlateformInfo({})
        this.systemOptions = res.body
        if(this.searchForm.plateformId){
          this.selectSystem(this.searchForm.plateformId)
        }
        this.selectModule()
      } catch (error) {
        this.$message.error('加载系统选项失败')
      }
    },
    selectSystem(value) {
      if (value) {
        // 加载模块选项
        this.moduleOptions = this.systemOptions.find(v => v.plateformId === value).studyModuleInfoList
      } else {
        this.moduleOptions = []
      }
    },
    selectModule() {
      if (this.searchForm.moduleId) {
        // 加载标签选项
        this.loadTagOptions()
      } else {
        this.tagOptions = []
      }
    },

    // 加载标签选项
    async loadTagOptions() {
      try {
        const res = await listCategoryInfo({
          moduleId: this.searchForm.moduleId,
          plateformId: this.searchForm.plateformId
        })
        this.tagOptions = removeEmptyChildren(res.body || [])
      } catch (error) {
        console.log(error)
        this.$message.error('加载标签选项失败')
      }
    },

    // 处理搜索
    async handleSearch() {
      this.loadData()
    },

    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        plateformId: undefined,
        moduleId: undefined,
        state: undefined,
        categoryPathList: [],
        operator: '',
        operatorId: '',
        operatorName: ''
      }
      this.loadData()
    },

    // 编辑关闭时的处理
    async handleEditClosed({ row }) {
      const column = { field: '' }
      switch (row.leve) {
        case 1:
          column.field = 'firstTag'
          break
        case 2:
          column.field = 'secondTag'
          break
        case 3:
          column.field = 'thirdTag'
          break
        default:
          return false
      }

      const $table = this.$refs.xGrid
      const cellValue = row[column.field]
      // 如果值为空，不允许关闭编辑
      if (!cellValue || cellValue.trim() === '') {
        this.$message.error('标签名称不能为空')
        // 重新激活编辑
        await $table.setEditCell(row, column.field)
        return false
      }

      // 验证长度
      if (cellValue.length < 2 || cellValue.length > 20) {
        this.$message.error('标签长度必须在2-20个字符之间')
        // 重新激活编辑
        await $table.setEditCell(row, column.field)
        return false
      }

      // 同一级标签不能重复
      const siblings = this.findParentNode(row.selfId).children
      const hasDuplicate = siblings.some(item => item[column.field] === cellValue && item.selfId !== row.selfId)
      if (hasDuplicate) {
        this.$message.error('同级下已存在相同名称')
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.content-config {
  padding: 8px 0;
  min-height: calc(100vh - 97px);
  .search-line {
    background: #fff;
    margin-bottom: 8px;
    border-radius: 4px;

    .form-item {
      margin-bottom: 8px;
      width: 100%;
      :deep(.ant-form-item-label) {
        min-width: 80px;
      }
      :deep(.ant-form-item-control-wrapper) {
        max-width: calc(100% - 80px);
      }
      &.operation-item {
        :deep(.ant-form-item-control) {
          text-align: right;
        }
        :deep(.ant-form-item-control-wrapper) {
          max-width: 100%;
        }
      }
    }
  }

  .operation-bar {
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
  }
  .table-container{
    height: calc(100vh - 270px);
  }

  :deep(.vxe-table--body-wrapper) {
    overflow-x: auto;
  }
}
</style>

